import React, { useState, useEffect } from "react";
import bannerImage from "./contuct.jpg";
import {
  FaXTwitter,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa6";

const BookingSection = () => {
  const [visible, setVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  const socialMediaIcons = [
    {
      icon: <FaXTwitter />,
      alt: "X",
      link: "https://x.com/Envision_is",
    },
    {
      icon: <FaLinkedinIn />,
      alt: "LinkedIn",
      link: "https://www.linkedin.com/company/envision-integrated-services-pvt-ltd/?trk=top_nav_home",
    },
    {
      icon: <FaYoutube />,
      alt: "YouTube",
      link: "https://www.youtube.com/@EnvisionISGroup",
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formData = new FormData(e.target);
      const data = {
        firstName: formData.get('firstName'),
        lastName: formData.get('lastName'),
        email: formData.get('email'),
        jobTitle: formData.get('jobTitle'),
        company: formData.get('company'),
        country: formData.get('country'),
        message: formData.get('message'),
        agreePolicy: formData.get('agreePolicy'),
        receiveUpdates: formData.get('receiveUpdates'),
      };

      // WhatsApp Integration
      const phoneNumber = "917842477203"; // Replace with your number
      const whatsappMessage = `
*New Consultation Request*
------------------------
*Name:* ${data.firstName} ${data.lastName}
*Email:* ${data.email}
*Job Title:* ${data.jobTitle}
*Company:* ${data.company}
*Country:* ${data.country}
*Message:* ${data.message}
*Agreed to Policy:* ${data.agreePolicy ? 'Yes' : 'No'}
*Receive Updates:* ${data.receiveUpdates ? 'Yes' : 'No'}
      `;

      const encodedMessage = encodeURIComponent(whatsappMessage);
      window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');

      alert('Thank you! Your consultation request has been sent.');
      e.target.reset();

    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error submitting your request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <style>{`
        /* ===== RESET & BASE ===== */
        .contact-section {
          width: 100%;
          background: #f4f7f9;
          padding: 56px 20px;
          box-sizing: border-box;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .contact-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0;
          border-radius: 18px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(15, 23, 42, 0.1);
          background: #ffffff;
        }

        /* ===== LEFT: IMAGE SIDE ===== */
        .contact-media {
          position: relative;
          min-height: 100%;
          background: url(${bannerImage}) no-repeat center center / cover;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 32px;
        }

        .contact-media::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(13,23,42,0.05) 0%, rgba(13,23,42,0.75) 100%);
        }

        .contact-media-text {
          position: relative;
          z-index: 2;
          color: #ffffff;
        }

        .contact-media-eyebrow {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 1.6px;
          text-transform: uppercase;
          color: #e8b923;
          margin: 0 0 10px 0;
        }

        .contact-media-heading {
          font-size: 24px;
          font-weight: 800;
          font-family: 'Montserrat', sans-serif;
          line-height: 1.3;
          margin: 0 0 16px 0;
        }

        .contact-media-desc {
          font-size: 13.5px;
          color: #dfeff5;
          line-height: 1.6;
          margin: 0 0 24px 0;
          max-width: 380px;
        }

        /* ===== SOCIAL ICONS ===== */
        .social-icons-container {
          position: relative;
          z-index: 2;
          display: flex;
          gap: 14px;
          // opacity: 0;
          // transform: translateY(20px);
          transition: all 0.5s ease-out;
        }

        .social-icons-container.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .social-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.12);
          border: 1px solid rgba(255, 255, 255, 0.25);
          transition: background 0.25s ease, transform 0.25s ease;
          color: #ffffff;
          text-decoration: none;
        }

        .social-icon:hover {
          background: #e8b923;
          transform: translateY(-3px);
          color: #0f172a;
        }

        .social-icon svg {
          width: 16px;
          height: 16px;
        }

        /* ===== RIGHT: FORM SIDE ===== */
        .form-container {
          padding: 40px;
          opacity: 0;
          transform: translateY(24px);
          transition: all 0.6s ease-out;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .form-container.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .form-eyebrow {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 1.6px;
          text-transform: uppercase;
          color: #0d7a93;
          margin: 0 0 8px 0;
        }

        .form-heading {
          font-size: 20px;
          font-weight: 800;
          font-family: 'Montserrat', sans-serif;
          color: #14213d;
          margin: 0 0 22px 0;
        }

        /* ===== FORM ELEMENTS ===== */
        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        .form-row {
          display: flex;
          gap: 12px;
        }

        .form-row input,
        .form-row select,
        textarea {
          flex: 1;
          padding: 11px 13px;
          border: 1px solid #dde3e8;
          border-radius: 8px;
          font-size: 13.5px;
          font-family: inherit;
          color: #14213d;
          background: #fafbfc;
          transition: border-color 0.25s ease, background 0.25s ease;
          outline: none;
          box-sizing: border-box;
        }

        .form-row input:focus,
        .form-row select:focus,
        textarea:focus {
          border-color: #0d7a93;
          background: #ffffff;
        }

        .form-row input::placeholder,
        textarea::placeholder {
          color: #9aa6b5;
        }

        textarea {
          width: 100%;
          min-height: 90px;
          resize: vertical;
        }

        .checkbox-row {
          font-size: 12px;
          color: #5b6472;
        }

        .checkbox-row label {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          line-height: 1.5;
          cursor: pointer;
        }

        .checkbox-row input[type="checkbox"] {
          margin-top: 3px;
          accent-color: #0d7a93;
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          cursor: pointer;
        }

        /* ===== SUBMIT BUTTON ===== */
        .submit-btn {
          background: #e8b923;
          border: none;
          padding: 13px 22px;
          font-size: 14px;
          font-weight: 700;
          border-radius: 8px;
          cursor: pointer;
          color: #0f172a;
          transition: background 0.25s ease, transform 0.25s ease;
          margin-top: 4px;
          position: relative;
        }

        .submit-btn:hover:not(:disabled) {
          background: #c9960c;
          transform: translateY(-2px);
        }

        .submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .submit-btn.loading {
          color: transparent;
        }

        .submit-btn.loading::after {
          content: '';
          position: absolute;
          width: 20px;
          height: 20px;
          top: 50%;
          left: 50%;
          margin-left: -10px;
          margin-top: -10px;
          border: 2px solid #0f172a;
          border-radius: 50%;
          border-top-color: transparent;
          animation: spinner 0.6s linear infinite;
        }

        @keyframes spinner {
          to { transform: rotate(360deg); }
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 1100px) {
          .contact-container {
            grid-template-columns: 1fr;
          }
          .contact-media {
            min-height: 280px;
            padding: 28px;
          }
          .form-container {
            padding: 32px;
          }
        }

        @media (max-width: 768px) {
          .contact-section {
            padding: 40px 16px;
          }
          .contact-media {
            min-height: 240px;
          }
          .contact-media-heading {
            font-size: 20px;
          }
          .form-row {
            flex-direction: column;
            gap: 14px;
          }
          .form-heading {
            font-size: 18px;
          }
          .form-container {
            padding: 28px;
          }
        }

        @media (max-width: 480px) {
          .contact-container {
            border-radius: 14px;
          }
          .contact-media {
            min-height: 200px;
            padding: 20px;
          }
          .contact-media-heading {
            font-size: 18px;
          }
          .contact-media-desc {
            font-size: 12.5px;
          }
          .form-container {
            padding: 22px;
          }
          .social-icon {
            width: 32px;
            height: 32px;
          }
          .social-icon svg {
            width: 14px;
            height: 14px;
          }
          .checkbox-row {
            font-size: 11px;
          }
          .submit-btn {
            padding: 11px 18px;
            font-size: 13px;
          }
          .form-row input,
          .form-row select,
          textarea {
            font-size: 12.5px;
            padding: 10px 12px;
          }
        }

        /* ===== SMALL SCREEN FIXES ===== */
        @media (max-width: 380px) {
          .contact-section {
            padding: 30px 10px;
          }
          .contact-media {
            min-height: 160px;
            padding: 16px;
          }
          .contact-media-heading {
            font-size: 16px;
          }
          .contact-media-desc {
            font-size: 11px;
          }
          .form-container {
            padding: 16px;
          }
          .form-heading {
            font-size: 16px;
          }
          .submit-btn {
            padding: 10px 14px;
            font-size: 12px;
          }
        }
      `}</style>

      <section className="contact-section">
        <div className="contact-container">
          {/* Left: Image side */}
          <div className="contact-media">
            <div className="contact-media-text">
              <p className="contact-media-eyebrow">Get In Touch</p>
              <h2 className="contact-media-heading">
                Let's build something great together
              </h2>
              <p className="contact-media-desc">
                Share your details and our team will reach out to discuss how
                Envision can help engineer your next big idea.
              </p>
            </div>

            <div className={`social-icons-container ${visible ? "visible" : ""}`}>
              {socialMediaIcons.map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label={social.alt}
                  style={{ transitionDelay: `${index * 0.1}s` }}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Right: Form side */}
          <div className={`form-container ${visible ? "visible" : ""}`}>
            <p className="form-eyebrow">Contact Us</p>
            <h3 className="form-heading">Request a Consultation</h3>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <input 
                  type="text" 
                  name="firstName"
                  placeholder="First Name" 
                  required 
                />
                <input 
                  type="text" 
                  name="lastName"
                  placeholder="Last Name" 
                  required 
                />
              </div>
              <div className="form-row">
                <input 
                  type="email" 
                  name="email"
                  placeholder="Work Email" 
                  required 
                />
                <input 
                  type="text" 
                  name="jobTitle"
                  placeholder="Job Title" 
                  required 
                />
              </div>
              <div className="form-row">
                <input 
                  type="text" 
                  name="company"
                  placeholder="Company" 
                  required 
                />
                <select name="country" required>
                  <option value="">Country</option>
                  <option value="India">India</option>
                  <option value="USA">USA</option>
                  <option value="UK">UK</option>
                  <option value="Australia">Australia</option>
                  <option value="Canada">Canada</option>
                  <option value="Germany">Germany</option>
                  <option value="France">France</option>
                </select>
              </div>
              <textarea 
                name="message"
                placeholder="Message"
              ></textarea>
              <div className="checkbox-row">
                <label>
                  <input 
                    type="checkbox" 
                    name="agreePolicy"
                    required 
                  /> 
                  I confirm, I have read and agree to Envision's Privacy Policy and consent to sharing my information.
                </label>
              </div>
              <div className="checkbox-row">
                <label>
                  <input 
                    type="checkbox" 
                    name="receiveUpdates"
                  /> 
                  I would like to receive alerts and updates from Envision.
                </label>
              </div>
              <button 
                type="submit" 
                className={`submit-btn ${isSubmitting ? 'loading' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookingSection;